import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
  modalStyleClass: {
    minWidth: "auto !important",
    padding: 0,
  },
  saveButton: {
    width: "100%",
    border: "1px solid #4D1277",
    color: "#fff",
    backgroundColor: "#4D1277",
    borderRadius: "6px",
    fontFamily: "poppins",
    fontWeight: 400,
    fontSize: "14px",
    "&:hover": {
      color: "#fff",
      backgroundColor: "#4D1277",
      boxShadow: "none",
    },
    textTransform: "capitalize",
    boxShadow: "none",
  },
}));

export default useStyles;

export const modalBoxStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "auto",
  bgcolor: "background.paper",
  borderRadius: "2px",
  boxShadow: 24,
  minHeight: "200px",
  minWidth: "400px",
  padding: "10px 13px",
};
